RivalIQ.apps.AccountSettings.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const Widget = widgets.AccountCompaniesWidget = Dashboard.models.Widget.extend({
        view: App.views.AccountCompanies,
        title: RivalIQ.strings.company_usage_account_companies_widget_title,

        viewMore: false,

        getExportOrientation: _.constant(RivalIQ.enums.orientation.PORTRAIT),

        exportFormats: [
            RivalIQ.enums.exportFormat.CSV
        ],

        exportTypes: [
            RivalIQ.enums.exportType.DOWNLOAD,
            RivalIQ.enums.exportType.SCHEDULE
        ],

        csvExportProps: function () {
            return {
                type: 'accountCompanies'
            };
        },

        getFilename: function () {
            return 'rivaliq_all_companies';
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.ACCOUNT_COMPANIES, Widget);

    const CompanySummaryWidget = Dashboard.models.Widget.extend({
        view: App.views.CompanySummary,
        title: 'Summary',
        viewMore: false,
        exportFormats: []
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.COMPANY_SUMMARY, CompanySummaryWidget);
});
